import React from 'react';
import SimpleMultiSelectPage from 'pages/wholeme/molecules/simpleMultiSelectPage/SimpleMultiSelectPage';
import { affinityData } from './affinityData';
import appStrings from '../../../../../common/app_strings';

const { wholeMe: { wholeMeAffinityIntake } } = appStrings;

const ProfileIdentityIntakeAffinityPage = ({
  paginationMeta,
  nextOnClick,
  prevOnClick,
  wholeMeClient,
  exitIconOnClickOverride,
}) => (
  <SimpleMultiSelectPage
    fields={affinityData}
    itemVariant="rectangle"
    isTwoColumns
    paginationMeta={paginationMeta}
    nextOnClick={nextOnClick}
    prevOnClick={prevOnClick}
    title={wholeMeAffinityIntake.title}
    subtitle={wholeMeAffinityIntake.subtitle}
    categoryId="identity"
    questionId="affinity"
    dataFetcher={wholeMeClient.fetchAffinityState}
    dataSaver={wholeMeClient.saveAffinityState}
    backgroundOverlay="/assets/profile/identity/affinity-overlay.svg"
    childrenOverrideStyles={{
      margin: '1.5rem 0 auto 0',
    }}
    exitIconOnClickOverride={exitIconOnClickOverride}
    skipPersonalization
  />
);

export default ProfileIdentityIntakeAffinityPage;
